import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import CalendarIcon from '../../../../Assets/Images/Calendar.svg';

const OpenPickerIcon = () => (
	<img
		src={CalendarIcon}
		alt='Calendar'
		style={{ position: 'relative', right: '-5px' }}
	/>
);

const DatePickerInput = ({ value, onChange, placeholder, width }) => {
	const slotProps = {
		inputAdornment: { position: 'start' },
		textField: { placeholder, size: 'small' }
	};

	const sx = {
		width,
		'& .MuiOutlinedInput-root': {
			paddingLeft: '0'
		},
		'& .MuiInputAdornment-root': {
			backgroundColor: '#B7D423',
			padding: '20px 15px',
			borderTopLeftRadius: '4px',
			borderBottomLeftRadius: '4px'
		}
	};

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<DatePicker
				value={value}
				onChange={onChange}
				format='DD MM YYYY'
				localeText={{
					fieldMonthPlaceholder: () => 'MM'
				}}
				slots={{ openPickerIcon: OpenPickerIcon }}
				slotProps={slotProps}
				sx={sx}
				maxDate={dayjs()}
			/>
		</LocalizationProvider>
	);
};

export default DatePickerInput;

DatePickerInput.propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.any,
	placeholder: PropTypes.any,
	width: PropTypes.any
};
